export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  mode: 'payment' | 'subscription';
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_SZlbobuy4ALFN7',
    priceId: 'price_1Rec4ECMG4kSsC1Q4cAyBNA8',
    name: 'ADAPT personal',
    description: 'Single user account',
    price: 0,
    currency: 'USD',
    mode: 'subscription'
  },
  {
    id: 'prod_SZlYPu78UuEs9g',
    priceId: 'price_1Rec1sCMG4kSsC1QJ92BdfFq',
    name: 'ADAPT start-up',
    description: 'The Adaptive Framework monthly subscription',
    price: 9.99,
    currency: 'USD',
    mode: 'subscription'
  },
  {
    id: 'prod_SZlaSMDorZ4yBQ',
    priceId: 'price_1Rec3PCMG4kSsC1QuPtDszy7',
    name: 'ADAPT Enterprise',
    description: 'The Adaptive Framework monthly subscription for enterprises needing > 10 users',
    price: 24.99,
    currency: 'USD',
    mode: 'subscription'
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
};

export const formatPrice = (price: number, currency: string = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: price % 1 === 0 ? 0 : 2,
  }).format(price);
};